export default __webpack_public_path__ + "static/media/tri.8194b0c7.svg";